import { Box, Stack, Typography } from "@mui/material";

export default function FireBalls() {
  return (
    <Stack direction="row" px={30}>
      <Box mt={10}>
        <img src={require("../Assets/Images/icon.webp")} alt="" style={{ width: "80%" }} />
      </Box>

      <Stack mt={10} ml={5}>
        <Typography color="#E94F37" fontWeight="bold" fontSize="100px">
          FIRE
        </Typography>

        <Typography color="#E94F37" fontWeight="bold" fontSize="100px">
          BALLS
        </Typography>

        <Stack
          bgcolor="#20487E"
          width={170}
          height="40px"
          alignItems="center"
          justifyContent="center"
          borderRadius={5}
        >
          <Typography color="#FFF" fontWeight="bold">
            Studio Brandweer
          </Typography>
        </Stack>

        <Stack direction="row" spacing={2} mt={5}>
          <Stack
            bgcolor="#C3FD48"
            width="58px"
            height="40px"
            alignItems="center"
            justifyContent="center"
            borderRadius={5}
          >
            <Typography color="#20487E" fontWeight="bold" fontSize={14}>
              Noa
            </Typography>
          </Stack>

          <Stack
            bgcolor="#FFDB5C"
            width="60px"
            height="40px"
            alignItems="center"
            justifyContent="center"
            borderRadius={5}
          >
            <Typography color="#20487E" fontWeight="bold" fontSize={14}>
              Silke
            </Typography>
          </Stack>

          <Stack
            bgcolor="#FDA2EE"
            width="70px"
            height="40px"
            alignItems="center"
            justifyContent="center"
            borderRadius={5}
          >
            <Typography color="#20487E" fontWeight="bold" fontSize={14}>
              Emilie
            </Typography>
          </Stack>

          <Stack
            bgcolor="#D6BDFF"
            width="60px"
            height="40px"
            alignItems="center"
            justifyContent="center"
            borderRadius={5}
          >
            <Typography color="#20487E" fontWeight="bold" fontSize={14}>
              Yara
            </Typography>
          </Stack>

          <Stack
            bgcolor="#25ABE4"
            width="60px"
            height="40px"
            alignItems="center"
            justifyContent="center"
            borderRadius={5}
          >
            <Typography color="#FFF" fontWeight="bold" fontSize={14}>
              Matt
            </Typography>
          </Stack>

          <Stack
            bgcolor="#E42525"
            width="60px"
            height="40px"
            alignItems="center"
            justifyContent="center"
            borderRadius={5}
          >
            <Typography color="#FFF" fontWeight="bold" fontSize={14}>
              Robin
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
